
import Vue from 'vue';
import { Getter, Action } from 'vuex-class';
import Component from 'vue-class-component';
import SearchCustomer from './SearchCustomer.vue';
import FileTable from './FileTable.vue';
import { Prop, Watch } from 'vue-property-decorator';
import { Message } from 'element-ui';
import * as util from '../conf';

@Component({
  components: { SearchCustomer, FileTable }
})
export default class ProductConsultation extends Vue {
  $refs: {
    [key: string]: any;
    validate: HTMLFormElement;
  };

  @Getter productSubsystemList: any;
  @Getter productModuleList: any;
  @Getter productEditionList: any;
  @Getter customerList: any;
  @Getter pmEmployeeList: any;

  @Getter feedbackResult: any;
  @Getter feedbackDetail: any;
  @Getter defaultAssignee: any;
  @Getter assignee: any;
  
  @Action getAssignee: Function;
  @Action('getDefaultAssignee') getDefaultAssignee: Function;  
  @Action('getProductSubsystemList') getProductSubsystemList: Function;
  @Action('getProductModuleList') getProductModuleList: Function;
  @Action('getProductEditionList') getProductEditionList: Function;
  @Action('getCustomerData') getCustomerData: Function;
  @Action('addInsideFeedback') addInsideFeedback: Function;
  @Action('getFeedbackDetailById') getFeedbackDetailById: Function;
  @Action('getPMEmpliyeeData') getPMEmpliyeeData: Function;
  @Prop() TypeEnum: number;

  subdisabled:boolean=false;
  chooseCustomerVisible: boolean = false;
  isActivation: boolean = false;
  newAss: any = {};
  isShowEnterpriseCode: boolean = false;
  roboturl:string='';
  feedbackGUID='';
  // 表单数据
  form: any = {
    CreatedUserCode:'',
    CreatedName:'',
    Ygsj:'',
    HandleUserCode:'',
    HandleName:'',
    EnterpriseCode: '',
    SubSystemGUID: '',
    SubSystemName: '',
    ModuleGUID: '',
    ModuleName: '',
    EditionGUID: '',
    EditionName: '',
    CustomerTopName: '',
    CustomerGUID: '',
    CustomerArea: '',
    CustomerFullName: '',
    CustomerShortName: '',
    FeedbackTheme: '',
    FeedbackDescribe: '',
    FileUpload: '',
    assignee: { name: '' },
    FromType:'',   // 来源
    TicketId:'',    // 来源主键    
    OriginalAnalysis: '', // 原来的反馈分析
    OriginalFeedbackGUID: '' // 原来的反馈ID
  };

  rules: any = {
    EnterpriseCode: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (!value) return callback(new Error('企业代码不能为空'));
          callback();
        },
        trigger: 'blur'
      }
    ],
    SubSystemGUID: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (!value) return callback(new Error('所属子系统不能为空'));
          callback();
        },
        trigger: 'blur'
      }
    ],
    ModuleGUID: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (!value) return callback(new Error('模块不能为空'));
          callback();
        },
        trigger: 'blur'
      }
    ],
    EditionGUID: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (!value) return callback(new Error('产品版本不能为空'));
          callback();
        },
        trigger: 'blur'
      }
    ],
    PmName: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (!value) return callback(new Error('二开PM不能为空'));
          callback();
        },
        trigger: 'blur'
      }
    ],
    ProjectName: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (!value) return callback(new Error('项目名称不能为空'));
          callback();
        },
        trigger: 'blur'
      }
    ],
    FeedbackTheme: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (!value) return callback(new Error('咨询主题不能为空'));
          callback();
        },
        trigger: 'blur'
      }
    ],
    FeedbackDescribe: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (!value) return callback(new Error('产品咨询内容不能为空'));
          callback();
        },
        trigger: 'blur'
      }
    ],
        Ygsj: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (!value) return callback(new Error('预估工期不能为空'));
          callback();
        },
        trigger: 'blur'
      }
    ]
  };

 setsubdisabled(value:boolean) {    
    this.subdisabled=value;
 }

  checkCuetomer(rule: any, value: any, callback: any) {
    // debugger
    // if (!value) return callback(new Error('客户名称不能为空'));
    // if (!this.customerList.data ||
    //     !this.customerList.data.find((item: any) => 
    //     item.CustomerFullName === value)
    // ) {
    //   return callback(new Error('客户名称无效'));
    // }
    callback();
  }

  checkCreatedUser(rule: any, value: any, callback: any) {    
    if (!value) return callback(new Error('创建人不能为空'));
    if (!this.pmEmployeeList.data ||!this.pmEmployeeList.data.find((item: any) => 
        item.PmName === value)) {
      return callback(new Error('创建人无效'));
    }
    callback();
  }

  created() {
    this.reactivation();
    this.form.CompayType = util.getUserAreaType();
    this.form.BUName = util.getUserBUName();
    this.getProductSubsystemList();
    this.getDefaultAssignee();
    this.getAssignee();
    this.rules.CustomerFullName = {
      validator: this.checkCuetomer,
      trigger: 'blur'
    };    

    this.rules.CreatedName = {
      validator: this.checkCreatedUser,
      trigger: 'click'
    }; 

    const user = JSON.parse(localStorage.logonUser);
     this.roboturl =
     "https://robotapi.fdcyun.com/?channel=corp&redirect=/&biz_id=CORP-XIAOSHOU&version=CORP-XIAOSHOU&userguid=" +
      user.UserGUID +
      "&phone=" +
      user.MobilePhone +
      "&email=" +
      user.Email +
      "&username=" +
      user.UserName +
      "&openid=" +
      user.UserCode +
      "";

    this.form.FromType=this.$route.query.fromType;
    this.form.TicketId=this.$route.query.ticketId;
    
    this.form.SubSystemGUID="11601";
    this.form.subSystemName="客户升级(含工具)";
          // 选择模块
      this.getProductModuleList({
        typeEnum: this.TypeEnum,
        subSystemName: this.form.subSystemName
      });
    this.form.ModuleGUID="11607";
    this.form.ModuleName="导数工具";
      // 选择版本
      this.getProductEditionList({
        typeEnum: this.TypeEnum,
        subSystemName: this.form.subSystemName
      });

      // 初始化      
      this.form.EditionGUID = "11622";
      this.form.EditionName = "默认版本";
      
      this.form.CustomerTopName = "武汉明源";
      this.form.CustomerGUID = "129ae3db-c617-453e-a0eb-1ff4f6e986cf";
      this.form.CustomerArea = "云南公司";
      this.form.CustomerFullName="武汉明源云科技有限公司";
      this.form.CustomerShortName = "武汉明源";

      this.form.HandleUserCode=user.UserCode;
      this.form.HandleName=user.UserName;
  }

  
  mounted(){
    // 通知打开页面的主体，页面加载完成    
    this.roboturl =this.roboturl +"&q="+this.form.FeedbackTheme;
  }


  // 重新激活的处理过程
  reactivation() {
    if (
      this.$route.query.FeedbackGUID &&
      this.$route.query.FeedbackGUID !== ''
    ) {
      this.isActivation = true;
      this.form.OriginalFeedbackGUID = this.$route.query.FeedbackGUID;
      this.getFeedbackDetailById({
        FeedbackGUID: this.$route.query.FeedbackGUID
      });
    }
  }

  @Watch('feedbackDetail.loading')
  watchFeedbackDetail(newVal: boolean, oldVal: boolean) {
    // oldVal: true, newVal: fasle, 表示接口请求完成，loading页面即将加载完成
    if (oldVal === true && newVal === false) {
      const data = JSON.parse(JSON.stringify(this.feedbackDetail.data));
      const detailInfo =
        data.length > 0
          ? data.find((item: any) => item.SourceEnum === 1) || data[0]
          : {};
      // 选择主系统
      this.form.SubSystemGUID = detailInfo.SubSystemGUID;
      this.form.SubSystemName = detailInfo.SubSystemName;
      this.setEnterpriseCode(this.form.SubSystemGUID);
      this.form.EnterpriseCode = detailInfo.EnterpriseCode;
      // 选择模块
      this.getProductModuleList({
        typeEnum: this.TypeEnum,
        subSystemName: detailInfo.SubSystemName
      });
      this.form.ModuleGUID = detailInfo.ModuleGUID;
      this.form.ModuleName = detailInfo.ModuleName;
      // 选择版本
      this.getProductEditionList({
        typeEnum: this.TypeEnum,
        subSystemName: detailInfo.SubSystemName
      });
      this.form.EditionGUID = detailInfo.EditionGUID;
      this.form.EditionName = detailInfo.EditionName;
      // 输入客户名称
      this.getCustomerData({
        keyword: detailInfo.CustomerFullName,
        isPage: false,
        top: 100
      });
      this.form.CustomerTopName = detailInfo.CustomerTopName;
      this.form.CustomerGUID = detailInfo.CustomerGUID;
      this.form.CustomerArea = detailInfo.CustomerArea;
      this.form.CustomerFullName = detailInfo.CustomerFullName;
      this.form.CustomerShortName = detailInfo.CustomerShortName;
      // 主题
      this.form.FeedbackTheme = detailInfo.FeedbackTheme;
      // 描述
      this.form.FeedbackDescribe = detailInfo.FeedbackDescribe;
      // 原反馈分析
      this.form.OriginalAnalysis = detailInfo.Analysis;
      // 附件
      this.form.FileUpload = detailInfo.FileUpload;
      this.$refs.filetable.appendFileList(
        detailInfo.FileUpload ? JSON.parse(detailInfo.FileUpload) : []
      );
      // 经办人
      this.form.assignee.name = detailInfo.OperateUserCode;
      this.newAss.displayName = detailInfo.OperateName;
    }
  }

  @Watch('defaultAssignee.loading')
  watchDefaultAssignee(newVal: boolean, oldVal: boolean) {
    // oldVal: true, newVal: fasle, 表示接口请求完成，loading页面即将加载完成
    if (oldVal === true && newVal === false) {
      this.setAssignee(this.form.SubSystemGUID);
      this.setEnterpriseCode(this.form.SubSystemGUID);
    }
  }

  @Watch('assignee.loading')
  watchAssignee(newVal: boolean, oldVal: boolean) {
    // oldVal: true, newVal: fasle, 表示接口请求完成，loading页面即将加载完成
    if (oldVal === true && newVal === false) {
      this.setAssignee(this.form.SubSystemGUID);
    }
  }

  // 选择创建人
  handleSelectCreatedUserCode(key:any){
    this.form.CreatedName=key.PmName;
    this.form.CreatedUserCode=key.PmUserCode;
  }

  // 选择处理人
  handleSelectHandleUserCode(key:any){   
    this.form.HandleName=key.PmName;
    this.form.HandleUserCode=key.PmUserCode;
  }

  // 选择子系统
  changeSubsystem(key: any) {
    this.setAssignee(key);
    this.setEnterpriseCode(key);
    this.form.ModuleGUID = '';
    this.form.EditionGUID = '';
    const subsystem = this.productSubsystemList.data.find(
      (item: any) => item.SubSystemGUID === key
    );
    if (subsystem) {
      this.getProductModuleList({
        subSystemName: subsystem.SubSystemName
      });
      this.getProductEditionList({
        subSystemName: subsystem.SubSystemName
      });
    }    
    this.$refs.form.validateField('SubSystemGUID');
  }

  // 选择模块
  changeModule(key: any) {
    this.$refs.form.validateField('ModuleGUID');
  }

  // 选择子系统
  changeEdition(key: any) {
    this.$refs.form.validateField('EditionGUID');
  }

  queryUserAsync(keyword: string, cb: Function) {
    let customerResult: any = [];
    if (keyword) {
      this.getPMEmpliyeeData({ keyword, isPage: false, top: 100 }).then(
        (data: any) => {
          if (data && data.Items) {
            data.Items.forEach(
              (item: any) => (item.value = item.PmName)
            );
            customerResult = data.Items;
          }
          cb(customerResult);
        }
      );
    } else {
      cb(customerResult);
    }
  }

  // 客户搜索结果(value表示的是下拉的文字)
  queryCustomerAsync(keyword: string, cb: Function) {
    let customerResult: any = [];
    if (keyword) {
      this.getCustomerData({ keyword, isPage: false, top: 100 }).then(
        (data: any) => {
          if (data && data.Items) {
            data.Items.forEach(
              (item: any) => (item.value = item.CustomerFullName)
            );
            customerResult = data.Items;
          }
          cb(customerResult);
        }
      );
    } else {
      cb(customerResult);
    }
  }


  // 设置默认经办人
  setAssignee(sysid: any) {
    // 先置为空
    this.newAss={};
    this.form.assignee.name='';
    this.defaultAssignee.data.map((item: any) => {
      if (item.SubSystemGuid === sysid) {
        this.assignee.data.map((ass: any) => {
          if (ass.id === item.JiraUserId.toString()) {
            this.newAss = ass;
            this.form.assignee.name = ass.name;
          }
        });
      }
    });
  }

  // 设置是否需要填写企业代码
  setEnterpriseCode(sysid: any) {
    // 云助手 10808
    // HightData 10809
    // 移动计划 11192
    // 反馈流程测试 11333
    const needEnterpriseCodeSys = ['10808', '10809', '11192', '11333'];
    if (needEnterpriseCodeSys.includes(sysid)) {
      this.defaultAssignee.data.map((item: any) => {
        if (item.SubSystemGuid === sysid) {
          this.isShowEnterpriseCode = !item.IsHandleByProject;
        }
      });
    } else {
      this.isShowEnterpriseCode = false;
    }
  }

  // 确定选择的客户（模糊搜索）
  handleSelectCustomer(item: any) {
    this.form.CustomerGUID = item.CustomerGUID;
    this.form.CustomerArea = item.CustomerArea; // 客户区域
    this.form.CustomerFullName = item.CustomerFullName; // 客户全称
    this.form.CustomerTopName = item.CustomerTopName; // 顶级客户(简称)
    this.form.CustomerShortName = item.CustomerShortName; // 客户简称
    this.$refs.form.validateField('CustomerFullName');
  }

  // 打开选择客户弹窗
  chooseCustomer() {
    this.chooseCustomerVisible = true;
  }

  // 关闭选择客户
  closeChooseCustomerVisible(close: boolean) {
    this.chooseCustomerVisible = false;
  }

  // 确定选择客户（弹窗选择）
  confirmSelectedCustomer(val: { [key: string]: any }) {
    if (!!val) {
      this.form.CustomerGUID = val.CustomerGUID; // 客户GUID
      this.form.CustomerArea = val.CustomerArea; // 客户区域
      this.form.CustomerFullName = val.CustomerFullName; // 客户全称
      this.form.CustomerTopName = val.CustomerTopName; // 顶级客户(简称)
      this.form.CustomerShortName = val.CustomerShortName; // 客户简称
    }
    this.chooseCustomerVisible = false;
    this.$refs.form.validateField('CustomerFullName');
  }

  confirmFileList(fileList: any[]) {
    this.form.FileUpload = JSON.stringify(fileList);
  }

   @Watch('feedbackResult.success', { deep: true })
     watchSubmitSuccess(newVal: boolean, oldVal: boolean) {
    if (newVal && newVal !== oldVal) {             
            setTimeout(() => {
            this.$router.push({
              path: '/feedback/detail?FeedbackGUID='+this.feedbackResult.data.FeedbackGUID,              
            });
      }, 500);
    }
  }

  // 提交表单
  onSubmit(formName: string) {
    const feedback={};
    const form = this.$refs[formName];
    form.validate((valid: any) => {
      if (valid) {
        this.subdisabled=true;
        this.form.TypeEnum = this.TypeEnum;
        const subsystem = this.productSubsystemList.data.find(
          (item: any) => item.SubSystemGUID === this.form.SubSystemGUID
        );
        this.form.SubSystemName = subsystem.SubSystemName;
        const moduleInfo = this.productModuleList.data.find(
          (item: any) => item.ModuleGUID === this.form.ModuleGUID
        );
        this.form.ModuleName = moduleInfo.ModuleName;
        const edition = this.productEditionList.data.find(
          (item: any) => item.EditionGUID === this.form.EditionGUID
        );
        this.form.EditionName = edition.EditionName;
        // 防止重复提交
        if (
          !this.feedbackResult.success ||
          this.feedbackResult.request.FeedbackTheme !== this.form.FeedbackTheme
        ) {
          const body = Object.assign({}, this.form); // 解决接口报错时，重复叠加data的问题
          this.addInsideFeedback(body);
        } else {
          Message.info('已经提交成功');
          this.subdisabled=false;
        }
      } else {
        return false;
      }
    });
  }
}
